import React from 'react'
import { Alert } from '@mui/material'
import { AccessTime } from '@mui/icons-material'
import Colors from 'utils/Colors'
import _ from 'lodash'
import styles from './styles'
import BuildFinancialPendings from './BuildFinancialPendings'
import BuildScoreData from './BuildScoreData'

const FinancialPendingsData = ({ bgc_data }) => {
  const classes = styles()
  const financialPendingsData = bgc_data?.financial_pendings_data?.details?.data
  const score = bgc_data?.credit_score_data?.quod_score
  const isApproved = bgc_data?.result === 'APPROVED'
  const reason = bgc_data?.financial_pendings_data?.reason
  const hasReviews = !_.isEmpty(bgc_data?.reviews)
  
  const getStatusText = () => {
    if (bgc_data?.result === 'WAITING_FOR_REVIEW') {
      return 'Revisão manual requerida'
    }
    if (hasReviews && !isApproved) {
      return 'Reprovado(a) após revisão manual'
    }
    if (hasReviews && isApproved) {
      return 'Aprovado(a) após revisão manual'
    }
    return !isApproved ? 'Reprovado(a) automaticamente'
    : score >= 600
    ? 'Aprovado(a) automaticamente por score'
    : 'Aprovado(a) automaticamente'
  }

  const getDescriptionText = () => (
    (isApproved && score >= 600) ? 
            'O score de crédito é alto o suficiente para que essa pessoa seja aprovada automaticamente na Análise de Crédito, dispensando a consulta de Pendências Financeiras.'
            : reason
  )
  


  return bgc_data ? (
    <div>
      {bgc_data?.status === 'PROCESSING' && (
        <Alert style={{ marginBottom: 12 }} color="primary" icon={<AccessTime />}>
          O Background Check ainda está processando, por favor aguarde para ter informações completas.
        </Alert>
      )}

     {score && <BuildScoreData score={score} />}

      {bgc_data?.status === 'PROCESSED' && (
        <div>
          <div  className={classes.scoreResume}>
            <span>
              <b>Situação:&nbsp;</b>
              <b style={{ color: isApproved ? Colors.green : Colors.red }}>{getStatusText()}</b>
            </span>
            <span>
              <b>Resultado da Análise:&nbsp;</b>
              {getDescriptionText()}
              </span>
          </div>
        </div>

      )}

      <br></br>


      {financialPendingsData && <BuildFinancialPendings financialPendingsData={financialPendingsData} />}
    </div>
  ) : (
    <div className={classes.expansibleContent}>
      <span>Nenhuma informação encontrada.</span>
    </div>
  )
}

export default FinancialPendingsData
